const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	classDisabled: 'disabled',

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.rangeSlider();
		this.disableSubmit();
		this.scrollToErrorMessage();
		this.customFileUpload();
		this.formatSSNInput();

		if ($('body.page-template-page-time-sheet').length > 0) {
			$(document).on('touchstart touchend click', '#digital_signature-pad_signature', function() {
				localStorage.setItem('signature', $('#signature').val());
			});
		}
	},

	formatSSNInput: function() {
		const ssnInput = document.getElementById('ssn');
		if (!ssnInput) {
			return;
		}
		// ssnInput.parentNode.insertBefore(errorDiv, ssnInput.nextSibling);

		const validateSSN = function() {
			let input = ssnInput.value.replace(/\D/g, ''); // Remove non-digits
			let formattedInput = '';

			// Format the input to match the SSN pattern
			if (input.length > 3) {
				formattedInput += input.substr(0, 3) + '-';
				input = input.substr(3);
			}
			if (input.length > 2) {
				formattedInput += input.substr(0, 2) + '-';
				input = input.substr(2);
			}
			formattedInput += input;

			// Limit input to 9 digits plus the two dashes
			if (formattedInput.length > 11) {
				formattedInput = formattedInput.substr(0, 11);
			}

			ssnInput.value = formattedInput;

			// Validate SSN length
			if (formattedInput.length !== 11) {
				ssnInput.classList.add('wpcf7-not-valid');
				document.querySelector('.contact-form__input-custom-error').classList.add('active');
			} else {
				ssnInput.classList.remove('wpcf7-not-valid');
				document.querySelector('.contact-form__input-custom-error').classList.remove('active');
			}
		};

		// Attach event listeners for input and focus events
		ssnInput.addEventListener('input', validateSSN);
		ssnInput.addEventListener('focus', validateSSN);
	},

	customFileUpload() {
		const fileInputs = document.querySelectorAll('.wpcf7-file');
		const labels = document.querySelectorAll('.custom-file-upload__label');

		fileInputs.forEach((fileInput, index) => {
			const uniqueId = `file-input-${index}`;
			fileInput.id = uniqueId;
			if (labels[index]) {
				labels[index].setAttribute('for', uniqueId);
			}
		});

		fileInputs.forEach((fileInput) => {
			fileInput.addEventListener('change', function() {
				updateLabel(this);
			});
		});

		const dropAreas = document.querySelectorAll('.custom-file-upload');
		setupDragAndDrop(dropAreas);

		function updateLabel(fileInput) {
			const label = document.querySelector(`label[for="${fileInput.id}"]`);
			const fileName = fileInput.files[0] ? fileInput.files[0].name : 'No file chosen';
			label.innerHTML = `<span class='custom-file-upload__button'>${fileName}</span>`;
		}

		function setupDragAndDrop(dropAreas) {
			dropAreas.forEach(dropArea => {
				['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
					dropArea.addEventListener(eventName, preventDefaults, false);
				});

				dropArea.addEventListener('drop', function(e) {
					handleDrop(e, this);
				}, false);
			});
		}

		function preventDefaults(e) {
			e.preventDefault();
			e.stopPropagation();
		}

		function handleDrop(e, dropArea) {
			const dt = e.dataTransfer;
			const files = dt.files;
			const fileInput = dropArea.querySelector('.wpcf7-file');
			if (fileInput && files.length > 0) {
				fileInput.files = files;
				updateLabel(fileInput);
			}
		}
	},

	disableSubmit() {
		$('.js-submit').on('click', function(event) {
			const ssnInput = $('#ssn');
			if (ssnInput.hasClass('wpcf7-not-valid') || ssnInput.val().trim() === '') {
				event.preventDefault();
				ssnInput.addClass('wpcf7-not-valid');
				$('.contact-form__input-custom-error').addClass('active');
				return false;
			}
			$(this).addClass(FormHelpers.classDisabled);
		});

		setTimeout(() => {
			if ($(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
				$(this).removeClass(FormHelpers.classDisabled);
			}
		}, 1000);

		// Listen for the 'wpcf7invalid' event which is triggered when the form has validation errors
		document.addEventListener('wpcf7invalid', function(event) {
			const form = $(event.target);
			if (form.is('.contact-form--join-team form')) {
				form.find('.js-submit').removeClass(FormHelpers.classDisabled);
				// Optionally, focus on the first invalid input
				form.find('.wpcf7-not-valid').first().focus();
			}
		}, false);

		$('.contact-form--join-team form').on('submit', function(e) {
			const ssnInput = $('#ssn');

			ssnInput.removeClass('wpcf7-not-valid');
			$('.contact-form__input-custom-error').removeClass('active');

			if (ssnInput.hasClass('wpcf7-not-valid') || ssnInput.val().trim() === '') {
				e.preventDefault();

				setTimeout(() => {
					ssnInput.addClass('wpcf7-not-valid');
					$('.contact-form__input-custom-error').addClass('active');
				}, 1500);
				return false;
			}
		});
	},

	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const form = $(e.target); // Assuming e.target is the form element

			if (form.length) {
				if (!($('body.page-template-page-time-sheet').length > 0)) {
					form.parents(formHolder).addClass(sentClass);
					$('.js-select').val(null).trigger('change');
					setTimeout(() => {
						$('.wpcf7-submit').removeClass(FormHelpers.classDisabled);
						$(formHolder).removeClass(sentClass);
					}, delay);

					const label = document.querySelectorAll('.custom-file-upload__label');
					label.forEach(element => {
						element.innerHTML = '<span class="custom-file-upload__button">Click to Upload</span> or drag and drop';
					});
				}

				if ($('body.page-template-page-time-sheet').length > 0) {
					// Serialize form and filter out empty fields and unwanted fields
					const formData = form.serializeArray().filter(field => field.value && !field.name.startsWith('_wpcf7'));

					// Send form data and signature to server
					$.ajax({
						url: window.fwsLocalized.ajaxUrl,
						method: 'POST',
						data: {
							action: 'generate_pdf',
							formData: formData,
							signatureSrc: localStorage.getItem('signature')
						},
						success: function(response) {
							const data = JSON.parse(response);

							if (data.pdf_url) {
								const link = document.createElement('a');
								link.href = data.pdf_url;
								link.download = 'ahivim_form_submission.pdf'; // You can set a custom filename here
								link.classList.add('temp-link');
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
							}
						}
					});
				}

			} else {
				console.error('Form element not found');
			}
		}, false);
	},

	scrollToErrorMessage: () => {
		document.addEventListener('wpcf7invalid', function() {
			setTimeout(function() {
				$('html').stop().animate({
					scrollTop: $('.wpcf7-not-valid-tip').eq(0).offset().top - 300
				}, 500, 'swing');
			}, 100);
		}, false);
	},

	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},
	rangeSlider() {
		const elRangeInputs = document.querySelectorAll('.range');

		function setProgress(elTarget) {
			const elRangeBar = elTarget.parentElement;
			const intThumbWidth = elRangeBar.clientHeight * 3;
			const intRangeBarWidth = elRangeBar.clientWidth - intThumbWidth;
			const intThumbWidthOffset = intThumbWidth / 2;
			const intProgressPosition = (elTarget.value - elTarget.min) / (elTarget.max - elTarget.min);
			const intRangePosition = (intRangeBarWidth * intProgressPosition) + intThumbWidthOffset;

			elRangeBar.style.background =
				'linear-gradient(to right, #5c92ff ' +
				intRangePosition + 'px, #e2e2ea ' +
				intRangePosition + 'px';
		}

		for (let i = 0; i < elRangeInputs.length; i++) {
			elRangeInputs[i].firstElementChild.addEventListener('input', function() {
				setProgress(this);
			});
			setProgress(elRangeInputs[i].firstElementChild);
		}
	},
};

export default FormHelpers;
